<div style="padding: 56.25% 0 0 0; position: relative; margin-top: 2px;">
    <iframe src = "https://conf.letscongress.eu/home/1505" 
    allow="autoplay; fullscreen" allowfullscreen mozallowfullscreen webkitallowfullscreen 
    scrolling="no"
    style="position: absolute; top: 0; left: 0; width: 100%; height: 3000px; border:none;"
    >
    </iframe>
</div>
